import { Injectable } from '@angular/core';

export interface ColumnDef {
  name: string;
  type?: ColumnType;
  show: boolean;
}

export class ColumnType {
  constructor(min: number, max: number, fixed: boolean = false) {
    this.minWidth = min;
    this.maxWidth = max;
    this.fixed = fixed;
  }
  minWidth: number;
  maxWidth: number;
  fixed: boolean;
}
@Injectable({
  providedIn: 'root',
})
export class ListingHelper {
  private columns: any = [];

  public addColumn(name: string, type: ColumnType, shown: boolean = false) {
    const newCol = {} as ColumnDef;
    newCol.name = name;
    newCol.type = type;
    newCol.show = shown;

    this.columns[name] = newCol;
  }

  public addDefaultColumn(name: string) {
    const foundDefault = Object.entries(this.columns)
      .map(([key, value]) => value as ColumnDef)
      .some((column) => !column.type);
    if (foundDefault === true) throw new Error('Default column already exists');
    const newCol = {} as ColumnDef;
    newCol.name = name;
    newCol.type = undefined;
    newCol.show = true;

    this.columns[name] = newCol;
  }

  public getAllColumnNames(): string[] {
    const allColumns = Object.entries(this.columns).map(([key, value]) => value as ColumnDef);

    const allColumnsShown = allColumns.filter((column) => column.show === true);

    const allColumnsShownNames = allColumnsShown.map((x) => x.name);

    return allColumnsShownNames;
  }

  public getColumn(name: string): ColumnDef | undefined {
    const currentColumn = this.columns[name];

    if (!currentColumn) throw new Error('Column name not recognized');

    return currentColumn;
  }

  public isShown(name: string): boolean {
    return this.columns[name].show;
  }

  public setShown(name: string, value: boolean) {
    return (this.columns[name].show = value);
  }

  public getWidth(name: string): number {
    const currentColumn = this.columns[name];

    if (!currentColumn) throw new Error('Column name not recognized');

    if (!currentColumn.type) return this.getDefaultColumnWidth();

    if ((currentColumn.type as ColumnDef)?.type?.fixed === true)
      return currentColumn.type.minWidth;

    const allColumns = Object.entries(this.columns).map(([key, value]) => value as ColumnDef);

    const columnsOfSameType = allColumns.filter((column) => column.type === currentColumn.type);

    const columnsShown = columnsOfSameType.filter((column) => column.show === true);

    const totalWidth = currentColumn.type.minWidth * columnsOfSameType.length;

    const tempWidth = totalWidth / columnsShown.length;

    const finalWidth = tempWidth > currentColumn.type.maxWidth ? currentColumn.type.maxWidth : tempWidth;

    return finalWidth;
  }

  private getDefaultColumnWidth(): number {
    const allColumns = Object.entries(this.columns).map(([key, value]) => value as ColumnDef);
    const columnsShown = allColumns.filter((column) => column.show === true && column.type && column.type.fixed === false);

    const widthOfOtherColumns = columnsShown.reduce((a, c) => a + this.getWidth(c.name), 0);

    return 100 - widthOfOtherColumns;
  }
}
